import * as React from 'react';
import { createElement } from 'react';
import { ResponsiveGrid } from '@alifd/next';
import { formatFormItems } from '@/components/form/form/form';
const CbayelChildForm = (props, ref) => {
    const { children, columns, spacing = [0, 16, 16, 0], emptyContent, status, isPreview: __isPreview, ...otherProps } = props;
    const isPreview = __isPreview || status === 'readonly';
    return (createElement(ResponsiveGrid, { gap: spacing, columns: columns, ref: ref }, children ? (formatFormItems(children, { ...otherProps, isPreview })) : (createElement("div", { className: "empty-content" }, emptyContent))));
};
const CbayelChildFormRef = React.forwardRef(CbayelChildForm);
export default CbayelChildFormRef;
